module.exports = __webpack_public_path__ + "img/20201102_195051.a30a2dd1.jpg";